import * as duoGetters from './duo.getters';
import * as duoRuleset from './duo.ruleset';
import * as duoUtils from './duo.utils';
import duoSchema from './duo.schema';
import duoActions from './duo.actions';
import duoMessages from './duo.messages';
import { Immutable } from '@play-co/replicant';
import { ReplicantModuleState } from '../utils';
import { Visit } from '../visit';
import { Pet } from '../buruburu/pet';
import { Care } from '../buruburu/care';
import { History } from '../buruburu/history';
import { duoAsyncGetters } from './duo.asyncGetters';

export type Duo = typeof Duo;
// eslint-disable-next-line no-redeclare
export namespace Duo {
  export const $DEPENDENCIES = {
    Visit,
    Pet,
    Care,
    History,
  };

  export const schema = duoSchema;
  export const ruleset = duoRuleset;
  export const messages = duoMessages(Duo);
  export const actions = duoActions(Duo, $DEPENDENCIES);
  export const asyncGetters = duoAsyncGetters(Duo);

  export const api = {
    ...duoGetters,
    ...duoUtils,
  };

  export type MutableState = ReplicantModuleState<Duo>;
  export type State = Immutable<MutableState>;
}
